export interface ComicChapter {
  id: string;
  num: number;
  title: string;
  views: string;
}

export interface ComicCharacter {
  name: string;
  role: string;
  intro: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  category: string;
  tags: string[];
  rating: number;
  chapters: number;
  status: "连载中" | "已完结";
  views: string;
  updateAt: string;
  intro: string;
  synopsis: string;
  cover: string;
  banner: string;
  isNew?: boolean;
  isHot?: boolean;
  characters: ComicCharacter[];
  chapterList: ComicChapter[];
}

export const categories = ["校园", "职场", "奇幻", "恋爱", "剧情"] as const;

export const comics: Comic[] = [
  {
    id: "sakura-last-class",
    title: "樱花绽放的最后一课",
    author: "金序珍",
    category: "校园",
    tags: ["青春", "治愈", "校园日常"],
    rating: 9.4,
    chapters: 120,
    status: "连载中",
    views: "2.1亿",
    updateAt: "今日更新",
    intro: "毕业前最后一个春天，转学生江理惠误入废弃音乐教室，却听见了三年后的自己唱着同一首歌。",
    synopsis:
      "临近毕业的春末，性格内向的少女江理惠转学来到首尔一所普通高中。她在音乐教室的旧钢琴前，偶然听到一首只在梦里出现过的旋律。随着旋律，她与神秘学长崔允一起追寻这首歌的来历，也在一次次合奏中重新打开封闭的内心。这是一部关于离别、和解与重新出发的青春群像剧。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20sakura%20petal%20falling%20over%20a%20high%20school%20classroom%20window%2C%20a%20girl%20with%20dark%20hair%20sitting%20at%20an%20old%20piano%2C%20soft%20warm%20cream%20and%20coral%20color%20palette%2C%20gentle%20afternoon%20light%2C%20clean%20manga%20composition%2C%20dreamy%20youthful%20atmosphere&width=640&height=880&seq=cover-sakura-01&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=wide%20panoramic%20Korean%20manhwa%20art%20of%20a%20sakura%20lined%20school%20courtyard%20at%20spring%2C%20soft%20pink%20petals%20drifting%2C%20students%20in%20uniforms%20as%20silhouettes%2C%20warm%20cream%20and%20coral%20gradient%20sky%2C%20cinematic%20banner%20composition&width=1600&height=500&seq=banner-sakura-01&orientation=landscape",
    isHot: true,
    characters: [
      { name: "江理惠", role: "女主角", intro: "内向敏感的音乐才女，用旋律代替说话。" },
      { name: "崔允", role: "男主角", intro: "温柔可靠的神秘学长，与旧钢琴有着不解之缘。" },
      { name: "朴夏恩", role: "好友", intro: "热情开朗的班长，江理惠在学校的第一个朋友。" },
    ],
    chapterList: [
      { id: "c1", num: 120, title: "终章·毕业式", views: "138万" },
      { id: "c2", num: 119, title: "同一首歌", views: "152万" },
      { id: "c3", num: 118, title: "旧琴键", views: "129万" },
      { id: "c4", num: 117, title: "春夜合奏", views: "141万" },
    ],
  },
  {
    id: "transfer-student-secret",
    title: "转学生的秘密",
    author: "柳在赫",
    category: "校园",
    tags: ["悬疑", "校园", "推理"],
    rating: 8.9,
    chapters: 64,
    status: "连载中",
    views: "9800万",
    updateAt: "2天前更新",
    intro: "每个转学生都带着过去的影子，而她，带着整所学校的秘密。",
    synopsis:
      "高三开学的第一天，全班都注意到了那个不同寻常的转学生——李素妍。她总能提前一步避开事故，也知道每个同学不为人知的过去。当校园接连发生神秘事件，班长金建宇开始怀疑，她究竟是从哪里来，又为什么如此了解这所学校。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20illustration%20of%20a%20schoolgirl%20standing%20in%20a%20dim%20hallway%20with%20mysterious%20glowing%20lockers%2C%20muted%20sage%20and%20warm%20amber%20tones%2C%20dramatic%20shadow%20play%2C%20cinematic%20manga%20cover%20composition&width=640&height=880&seq=cover-transfer-02&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=wide%20dark%20academic%20hallway%20with%20rows%20of%20metal%20lockers%20and%20single%20figure%20walking%20away%2C%20moody%20amber%20and%20sage%20lighting%2C%20Korean%20webtoon%20cinematic%20banner&width=1600&height=500&seq=banner-transfer-02&orientation=landscape",
    characters: [
      { name: "李素妍", role: "转学生", intro: "带着整所学校秘密的神秘少女。" },
      { name: "金建宇", role: "班长", intro: "好奇心旺盛的观察者，试图揭开她的真相。" },
    ],
    chapterList: [
      { id: "c1", num: 64, title: "真相的钥匙", views: "76万" },
      { id: "c2", num: 63, title: "走廊尽头的灯", views: "84万" },
      { id: "c3", num: 62, title: "未寄出的信", views: "71万" },
    ],
  },
  {
    id: "midnight-overtime",
    title: "午夜加班指南",
    author: "郑多美",
    category: "职场",
    tags: ["社畜", "喜剧", "职场"],
    rating: 9.1,
    chapters: 96,
    status: "连载中",
    views: "1.5亿",
    updateAt: "今日更新",
    intro: "凌晨两点的办公室，藏着每个打工人的生存智慧与爆笑日常。",
    synopsis:
      "新人设计师南多仁终于进入梦寐以求的广告公司，却发现这里的生存法则比她想象的残酷又有趣。白天是创意总监的咆哮，午夜则是部门同事们的互助会。这是一部献给所有职场人的爆笑疗愈漫画，用幽默化解加班的疲惫。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20illustration%20of%20a%20young%20office%20worker%20at%20a%20desk%20late%20at%20night%20with%20city%20lights%20through%20window%2C%20cup%20of%20coffee%20steaming%2C%20warm%20coral%20and%20deep%20ink%20color%20palette%2C%20humorous%20expressive%20style%2C%20modern%20manga%20cover&width=640&height=880&seq=cover-office-03&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=wide%20panorama%20of%20a%20modern%20office%20at%20midnight%20lit%20by%20warm%20desk%20lamps%20and%20city%20skyline%20outside%2C%20empty%20cubicles%2C%20moody%20coral%20and%20ink%20tones%2C%20Korean%20webtoon%20banner&width=1600&height=500&seq=banner-office-03&orientation=landscape",
    isHot: true,
    characters: [
      { name: "南多仁", role: "设计师", intro: "从菜鸟成长起来的资深加班人。" },
      { name: "姜组长", role: "创意总监", intro: "白天咆哮、晚上靠谱的宝藏领导。" },
    ],
    chapterList: [
      { id: "c1", num: 96, title: "年会的修罗场", views: "98万" },
      { id: "c2", num: 95, title: "甲方的一百种改法", views: "112万" },
      { id: "c3", num: 94, title: "续命咖啡", views: "105万" },
    ],
  },
  {
    id: "first-cup-coffee",
    title: "新人的第一杯咖啡",
    author: "白智秀",
    category: "职场",
    tags: ["成长", "治愈", "职场"],
    rating: 8.7,
    chapters: 48,
    status: "连载中",
    views: "6200万",
    updateAt: "3天前更新",
    intro: "入职第一天的慌张，都藏在一杯还没泡开的咖啡里。",
    synopsis:
      "刚从大学毕业的尹瑞真，第一天上班就闹出各种乌龙。从不会用咖啡机，到逐渐独当一面，她在同事们的陪伴与鼓励下，一点点找到属于自己的节奏。这是一个关于职场新人笨拙而温暖的成长故事。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20gentle%20illustration%20of%20a%20nervous%20young%20woman%20holding%20a%20paper%20coffee%20cup%20in%20a%20bright%20modern%20office%2C%20soft%20cream%20and%20sage%20green%20color%20palette%2C%20warm%20lighting%2C%20cozy%20heartwarming%20manga%20cover%20style&width=640&height=880&seq=cover-coffee-04&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=wide%20cozy%20bright%20office%20break%20room%20with%20coffee%20machine%20and%20morning%20sunlight%20streaming%20in%2C%20warm%20cream%20and%20sage%20tones%2C%20Korean%20webtoon%20heartwarming%20banner&width=1600&height=500&seq=banner-coffee-04&orientation=landscape",
    characters: [
      { name: "尹瑞真", role: "新人", intro: "笨拙但努力，正在慢慢成长。" },
      { name: "前辈", role: "导师", intro: "毒舌却心软，总在关键时刻帮忙。" },
    ],
    chapterList: [
      { id: "c1", num: 48, title: "第一次独立汇报", views: "41万" },
      { id: "c2", num: 47, title: "咖啡机使用指南", views: "38万" },
    ],
  },
  {
    id: "otherworld-cafe",
    title: "异界咖啡馆",
    author: "黄敏书",
    category: "奇幻",
    tags: ["异世界", "治愈", "冒险"],
    rating: 9.6,
    chapters: 158,
    status: "连载中",
    views: "3.2亿",
    updateAt: "今日更新",
    intro: "推开这扇门，每一杯咖啡都会带你进入一个全新的世界。",
    synopsis:
      "失业的青年韩智宇误入一家只在午夜营业的咖啡馆，店主是一只会说人话的白猫。白猫交给他一把钥匙，让他替迷路的旅人调配通往异世界的咖啡。每一杯饮品背后，都是一段需要被治愈的旅程。作品以单元剧形式展开，温柔又充满想象力。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20illustration%20of%20a%20magical%20cafe%20counter%20with%20glowing%20coffee%20cups%20and%20a%20white%20cat%20shopkeeper%2C%20warm%20golden%20amber%20and%20coral%20lighting%2C%20whimsical%20cozy%20atmosphere%2C%20high%20detail%20manga%20cover%20art&width=640&height=880&seq=cover-cafe-05&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=wide%20magical%20fantasy%20cafe%20interior%20with%20flying%20sparkles%20and%20warm%20golden%20light%2C%20starry%20doorways%20opening%20to%20other%20worlds%2C%20amber%20and%20coral%20palette%2C%20Korean%20webtoon%20epic%20banner&width=1600&height=500&seq=banner-cafe-05&orientation=landscape",
    isHot: true,
    isNew: true,
    characters: [
      { name: "韩智宇", role: "咖啡馆学徒", intro: "失业青年，命运般推开那扇午夜的门。" },
      { name: "白猫店主", role: "神秘店主", intro: "会说人话的白猫，掌握异界钥匙。" },
    ],
    chapterList: [
      { id: "c1", num: 158, title: "失落的王国", views: "176万" },
      { id: "c2", num: 157, title: "月亮的眼泪", views: "184万" },
      { id: "c3", num: 156, title: "永不熄灭的灯", views: "168万" },
    ],
  },
  {
    id: "dragon-tamer",
    title: "驯龙师与守门人",
    author: "朴镇宇",
    category: "奇幻",
    tags: ["冒险", "热血", "战斗"],
    rating: 9.2,
    chapters: 132,
    status: "连载中",
    views: "2.6亿",
    updateAt: "1天前更新",
    intro: "当最弱的驯龙师遇上最强的守门人，命运就此改写。",
    synopsis:
      "在巨龙横行的架空大陆，驯龙师的能力以天赋血脉而定。资质平平的少年具太研却意外契约了传说中的灾厄之龙。面对守门人军团与野心家的围剿，他与伙伴们踏上拯救大陆的旅程。宏大的世界观与酣畅的战斗场面是本作最大看点。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20epic%20fantasy%20illustration%20of%20a%20young%20rider%20standing%20before%20a%20giant%20dragon%20on%20a%20cliff%20at%20dusk%2C%20coral%20and%20deep%20amber%20color%20palette%2C%20dramatic%20sky%2C%20dynamic%20heroic%20manga%20cover%20composition&width=640&height=880&seq=cover-dragon-06&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=wide%20epic%20fantasy%20battlefield%20with%20a%20dragon%20spreading%20wings%20over%20a%20valley%20at%20sunset%2C%20warm%20coral%20and%20amber%20sky%2C%20Korean%20webtoon%20cinematic%20banner&width=1600&height=500&seq=banner-dragon-06&orientation=landscape",
    isHot: true,
    characters: [
      { name: "具太研", role: "驯龙师", intro: "资质最弱却契约灾厄之龙的少年。" },
      { name: "守门人·绫", role: "搭档", intro: "守护遗迹的最强守门人。" },
    ],
    chapterList: [
      { id: "c1", num: 132, title: "王城之战", views: "143万" },
      { id: "c2", num: 131, title: "龙之觉醒", views: "151万" },
      { id: "c3", num: 130, title: "旧日的盟约", views: "137万" },
    ],
  },
  {
    id: "snow-first-day",
    title: "初雪那天",
    author: "尹河允",
    category: "恋爱",
    tags: ["纯爱", "冬季", "治愈"],
    rating: 9.0,
    chapters: 78,
    status: "连载中",
    views: "1.1亿",
    updateAt: "今日更新",
    intro: "如果初雪那天许下的愿望，真的能实现呢？",
    synopsis:
      "便利店打工的冬夜里，少女林夏雨在初雪中遇见了总在深夜买同一种热可可的男生周载沅。两个习惯把心事藏起来的人，因为一场雪慢慢靠近。细腻的心理描写与冬日氛围感，让无数读者心动不已。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20illustration%20of%20a%20couple%20standing%20under%20falling%20snow%20outside%20a%20warm%20lit%20convenience%20store%20at%20night%2C%20soft%20cream%20and%20cool%20white%20with%20coral%20accents%2C%20gentle%20intimate%20manga%20cover%20art&width=640&height=880&seq=cover-snow-07&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=wide%20romantic%20night%20street%20with%20gentle%20snowfall%20and%20warm%20storefront%20lights%2C%20two%20figures%20walking%20close%20together%2C%20cream%20and%20coral%20palette%2C%20Korean%20webtoon%20dreamy%20banner&width=1600&height=500&seq=banner-snow-07&orientation=landscape",
    isNew: true,
    characters: [
      { name: "林夏雨", role: "女主角", intro: "在便利店打工的安静少女。" },
      { name: "周载沅", role: "男主角", intro: "总在深夜买热可可的神秘男生。" },
    ],
    chapterList: [
      { id: "c1", num: 78, title: "融化", views: "89万" },
      { id: "c2", num: 77, title: "同一把伞", views: "93万" },
      { id: "c3", num: 76, title: "热可可的温度", views: "85万" },
    ],
  },
  {
    id: "signal-chapter7",
    title: "心动信号第七话",
    author: "崔恩彩",
    category: "恋爱",
    tags: ["青春", "甜宠", "校园"],
    rating: 8.8,
    chapters: 52,
    status: "已完结",
    views: "7400万",
    updateAt: "已完结",
    intro: "暗恋七年的秘密，终于在第七话被全部说出口。",
    synopsis:
      "高三女生韩絮暗恋同桌朴东赫整整七年，却始终没有勇气表白。当她决定在毕业前写完那本记录心情的漫画时，故事出现了意料之外的转折。这是一部轻松甜宠的校园恋爱喜剧。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20sweet%20romance%20illustration%20of%20two%20high%20school%20deskmates%20sitting%20side%20by%20side%20with%20a%20notebook%20between%20them%2C%20blushing%20cheeks%2C%20warm%20coral%20and%20cream%20palette%2C%20bright%20youthful%20manga%20cover&width=640&height=880&seq=cover-signal-08&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=wide%20bright%20sunny%20classroom%20with%20notebooks%20and%20warm%20sunlight%2C%20two%20silhouettes%20close%20together%2C%20coral%20and%20cream%20tones%2C%20Korean%20webtoon%20sweet%20banner&width=1600&height=500&seq=banner-signal-08&orientation=landscape",
    characters: [
      { name: "韩絮", role: "女主角", intro: "暗恋同桌七年的漫画家少女。" },
      { name: "朴东赫", role: "男主角", intro: "看起来木讷其实心细的学霸。" },
    ],
    chapterList: [
      { id: "c1", num: 52, title: "最终话·告白", views: "67万" },
      { id: "c2", num: 51, title: "心跳加速", views: "59万" },
    ],
  },
  {
    id: "hanriver-bookstore",
    title: "汉江边的老书店",
    author: "吴诗妍",
    category: "剧情",
    tags: ["文艺", "治愈", "人生"],
    rating: 9.3,
    chapters: 88,
    status: "连载中",
    views: "1.3亿",
    updateAt: "2天前更新",
    intro: "一家只收旧信的老书店，收留了城市里所有无处安放的心事。",
    synopsis:
      "经营着祖父留下的旧书店的宋智恩，有一个特别的规矩——可以用一封手写信换取一本书。每晚打烊后，她会展开那些陌生人的信，听他们讲述各自的人生。温润的笔触描绘出都市人的孤独与温暖，被读者称为“治愈系神作”。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20literary%20illustration%20of%20a%20cozy%20old%20bookstore%20interior%20with%20stacked%20books%20and%20warm%20lamplight%2C%20a%20young%20woman%20reading%20a%20letter%2C%20cream%20amber%20and%20deep%20ink%20palette%2C%20quiet%20nostalgic%20manga%20cover%20art&width=640&height=880&seq=cover-bookstore-09&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=wide%20evening%20riverbank%20with%20a%20small%20warm%20lit%20bookstore%20along%20the%20Han%20river%2C%20reflections%20on%20water%2C%20amber%20and%20ink%20tones%2C%20Korean%20webtoon%20nostalgic%20banner&width=1600&height=500&seq=banner-bookstore-09&orientation=landscape",
    isHot: true,
    characters: [
      { name: "宋智恩", role: "店主", intro: "守护祖父书店的温暖少女。" },
      { name: "韩星野", role: "常客", intro: "每周都来寄信的神秘作家。" },
    ],
    chapterList: [
      { id: "c1", num: 88, title: "回信", views: "102万" },
      { id: "c2", num: 87, title: "旧照片", views: "95万" },
      { id: "c3", num: 86, title: "未拆封的信", views: "90万" },
    ],
  },
  {
    id: "seoul-countdown",
    title: "首尔站倒计时",
    author: "安太焕",
    category: "剧情",
    tags: ["悬疑", "科幻", "紧张"],
    rating: 8.6,
    chapters: 42,
    status: "连载中",
    views: "5600万",
    updateAt: "1天前更新",
    intro: "当整个首尔陷入同一天的循环，只有她记得发生过什么。",
    synopsis:
      "首尔站每天都会在同一时刻发生一次离奇事故，而只有地铁播音员金珠贤记得每一次循环。为了解开循环的秘密、救下素不相识的人们，她必须在24小时内找出真相。紧张刺激的时间循环设定，反转层层递进。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20illustration%20of%20a%20subway%20announcer%20in%20a%20moody%20train%20station%20with%20a%20clock%20overlay%2C%20suspenseful%20sage%20and%20amber%20lighting%2C%20tension%20filled%20cinematic%20manga%20cover&width=640&height=880&seq=cover-seoul-10&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=wide%20futuristic%20subway%20station%20interior%20with%20giant%20clocks%20and%20glowing%20screens%2C%20moody%20amber%20and%20sage%20tones%2C%20Korean%20webtoon%20sci-fi%20thriller%20banner&width=1600&height=500&seq=banner-seoul-10&orientation=landscape",
    characters: [
      { name: "金珠贤", role: "女主播", intro: "唯一记得循环的播音员。" },
      { name: "朴刑警", role: "搭档", intro: "追查事故真相的执着刑警。" },
    ],
    chapterList: [
      { id: "c1", num: 42, title: "最后一班车", views: "47万" },
      { id: "c2", num: 41, title: "循环的缺口", views: "43万" },
    ],
  },
  {
    id: "nextdoor-programmer",
    title: "隔壁的程序员先生",
    author: "李珉周",
    category: "恋爱",
    tags: ["都市", "甜宠", "职场"],
    rating: 8.5,
    chapters: 36,
    status: "已完结",
    views: "4800万",
    updateAt: "已完结",
    intro: "住在隔壁的顶尖程序员，其实是个不会表达情感的温柔笨蛋。",
    synopsis:
      "自由插画师姜娜恩的新邻居，是业内知名的天才程序员都泰硕。两个人因为一次快递乌龙意外认识，又在一次次深夜送奶茶、修电脑中渐生情愫。都市男女的轻松恋爱日常，甜度适中笑点密集。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20urban%20romance%20illustration%20of%20a%20casual%20young%20man%20with%20a%20laptop%20and%20a%20girl%20holding%20milk%20tea%20in%20an%20apartment%20hallway%2C%20warm%20coral%20and%20cream%20tones%2C%20charming%20lighthearted%20manga%20cover&width=640&height=880&seq=cover-programmer-11&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=wide%20cozy%20apartment%20building%20corridor%20with%20warm%20evening%20light%20and%20two%20neighbor%20doors%2C%20coral%20and%20cream%20palette%2C%20Korean%20webtoon%20urban%20romance%20banner&width=1600&height=500&seq=banner-programmer-11&orientation=landscape",
    characters: [
      { name: "姜娜恩", role: "插画师", intro: "自由职业的元气少女。" },
      { name: "都泰硕", role: "程序员", intro: "高智商低情商的温柔邻居。" },
    ],
    chapterList: [
      { id: "c1", num: 36, title: "最终章·晚安", views: "38万" },
      { id: "c2", num: 35, title: "修电脑的夜晚", views: "41万" },
    ],
  },
  {
    id: "moonlight-chess",
    title: "月影下的棋手",
    author: "郑旻奎",
    category: "奇幻",
    tags: ["奇幻", "棋局", "成长"],
    rating: 8.9,
    chapters: 70,
    status: "连载中",
    views: "8100万",
    updateAt: "今日更新",
    intro: "月圆之夜，棋盘上的每一子，都是命运的抉择。",
    synopsis:
      "在古老的棋会中，棋手们以灵魂为注，与掌管月影的棋灵对弈。天赋异禀的少年沈在民为救回患病的妹妹，必须连续赢得九十九局传说对局。棋局即人生，每一步都是成长的证明。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystical%20illustration%20of%20a%20young%20chess%20player%20seated%20at%20a%20glowing%20board%20under%20a%20full%20moon%2C%20ethereal%20amber%20and%20coral%20lighting%2C%20moonlight%20rays%2C%20legendary%20manga%20cover%20art&width=640&height=880&seq=cover-chess-12&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=wide%20mystical%20night%20pavilion%20with%20a%20glowing%20chess%20board%20under%20a%20huge%20full%20moon%2C%20floating%20chess%20pieces%2C%20amber%20and%20coral%20tones%2C%20Korean%20webtoon%20legendary%20banner&width=1600&height=500&seq=banner-chess-12&orientation=landscape",
    isNew: true,
    characters: [
      { name: "沈在民", role: "棋手", intro: "为救妹妹踏上传说对局的少年。" },
      { name: "月影棋灵", role: "神秘存在", intro: "掌控棋局规则的神祇。" },
    ],
    chapterList: [
      { id: "c1", num: 70, title: "第九十九局", views: "61万" },
      { id: "c2", num: 69, title: "灵魂为注", views: "57万" },
    ],
  },
];

export const faqItems = [
  {
    q: "什么是羞羞漫画韩国？",
    a: "羞羞漫画韩国是一个专注于韩国漫画（Manhwa）的内容推荐平台，收录校园、职场、奇幻、恋爱、剧情等热门题材，并提供实时榜单与分类浏览，帮助读者快速发现感兴趣的漫画作品。",
  },
  {
    q: "网站上收录的漫画有哪些题材分类？",
    a: "我们目前主要设有校园、职场、奇幻、恋爱、剧情五大分类，并持续扩充更多细分题材。每个分类下都有详细的标签与更新信息，方便读者按口味筛选。",
  },
  {
    q: "如何找到最近更新的作品？",
    a: "你可以在首页的新作速递板块查看最新上架与更新的作品，也可以前往实时榜单查看周榜、人气榜与新人榜，第一时间掌握热门动态。",
  },
  {
    q: "作品的评分和热度是怎么来的？",
    a: "评分与热度基于读者反馈与平台综合数据计算，用于帮助读者判断作品的口碑与关注度，仅作为参考，最终是否喜欢还请以阅读体验为准。",
  },
  {
    q: "我可以在网站上提交漫画推荐吗？",
    a: "当然可以。欢迎通过联系我们页面提交你喜欢的韩国漫画与推荐理由，我们会认真评估并纳入收录范围，让更多读者发现优秀作品。",
  },
];